export default __webpack_public_path__ + "static/media/s-isch-mer-alles-ei-ding.f133b1b9.pdf";